import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativeBackOfANapkinRoute extends Route {
  @service store;
  @service currentUser;
  @service router;

  setupController(controller, model) {
    super.setupController(controller, model);
    model.bon.then(async (results) => {
      const bon = results ?? this.store.createRecord('bon');
      if (bon.id) {
        await this.revalidateImages(bon);
      }
      controller.set('bon', bon);
      // controller.set('editMode', true);

      //if a bon object already exists run formatBon to fill value fields in the object
      if (bon.id) {
        controller.get('formatBon')?.();
      }
    });
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.set('index', 0);
    controller.set('editMode', false);
    controller.set('showBonSlideover', false);
    controller.set('showPpwSlideover', false);
    controller.set('showInvestmentConfidenceSlideover', false);
    controller.set('showReturnConfidenceSlideover', false);
    controller.set('showUpsellValueSlideover', false);
    controller.set('showFteSlideover', false);
  }

  beforeModel() {
    this.router.transitionTo('backlog.initiatives.initiative.investments');
  }

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativeBackOfANapkinRoute,
);
